
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses",
      function () {
        return require("private-next-pages/courses.tsx");
      }
    ]);
  